import { _ } from "../../core/polyglot/polyglot.js";
import { widget } from "@foretagsplatsen/widgetjs";
import sectionWidget from "../../core/widgets/sectionWidget.js";

/**
 * List budgets by fiscal year.
 * If a budget is selected, it is highlighted in the list.
 *
 * @param {Budget[]} [spec.budgets] - List of budgets.
 */
const budgetListWidget = widget.subclass((that, my) => {
	my.initialize = function ({ budgets = [] }) {
		my.super(...arguments);
		my.budgets = budgets;
		my.selectedBudget = null;
		that.budgetSelected = my.events.createEvent();
	};

	that.getBudgets = function () {
		return my.budgets;
	};

	that.setBudgets = function (budgets) {
		my.budgets = budgets;
		that.update();
	};

	that.getSelectedBudget = function () {
		return my.selectedBudget;
	};

	that.selectBudget = function (budget) {
		if (my.selectedBudget === budget) {
			return;
		}

		my.selectedBudget = budget;
		that.budgetSelected.trigger(budget);
		that.update();
	};

	that.unselectBudget = function () {
		that.selectBudget(null);
	};

	that.renderContentOn = function (html) {
		const groupedBudgets = my.getBudgetsByFiscalYear();

		html.render(
			[...groupedBudgets.keys()]
				.sort((a, b) => (a.endsBefore(b) ? 1 : -1))
				.map((year) =>
					my.budgetsSectionRenderer(groupedBudgets.get(year), year),
				),
		);
	};

	my.budgetsSectionRenderer = function (budgets, year) {
		return sectionWidget({
			title: year.toSmartString(),
			content: (html) => {
				html.div(
					{
						klass: "budget-list",
						"data-test": "budget-list",
					},

					budgets.map((budget) => my.budgetRenderer(budget)),
				);
			},
		});
	};

	my.budgetRenderer = function (budget) {
		return (html) => {
			html.div(
				{
					klass: [
						"budget-file",
						{ active: my.isBudgetSelected(budget) },
						{ current: budget.isCurrent() },
					],
					"data-test": "budget-file",
					dblclick: () =>
						my.redirectTo(`budget-editor/${budget.getId()}`),
					click: () => that.selectBudget(budget),
				},
				html.div({
					klass: [
						"doc-icon",
						{ "user-hidden": !budget.isVisibleToAllUsers() },
					],
				}),
				html.div(
					{ klass: "name" },
					html.a(
						{ href: my.linkTo(`budget-editor/${budget.getId()}`) },
						budget.getName(),
						(html) => {
							if (!budget.isCurrent()) {
								return;
							}
							html.p("(", _("default"), ")");
						},
					),
				),
			);
		};
	};

	my.getBudgetsByFiscalYear = function () {
		return my.budgets.reduce((acc, budget) => {
			const fiscalYear = budget.getFiscalYear();

			const yearBudgets = acc.get(fiscalYear) || [];

			if (budget.isCurrent()) {
				acc.set(fiscalYear, [budget, ...yearBudgets]);
			} else {
				acc.set(fiscalYear, [...yearBudgets, budget]);
			}

			return acc;
		}, new Map());
	};

	my.isBudgetSelected = function (budget) {
		return my.selectedBudget === budget;
	};
});

export default budgetListWidget;
